import _ from "lodash";
import {Clausepart, DocumentSection} from "common/types/document";
import {
  clauseTemplateCacheKey,
  processClauseLinkTemplate,
} from "./process_clause_link_template";

function replaceClauseObjectsWithTagsImpl(
  text: string,
  documentClauseparts: Clausepart[],
  documentSections: DocumentSection[],
  documentId?: number,
): string {
  const matches = processClauseLinkTemplate(
    text,
    documentClauseparts,
    documentSections,
    documentId,
  );

  let output = "";
  let lastIndex = 0;
  for (const {regExpExec, clauseData} of matches) {
    const between = text.slice(lastIndex, regExpExec.index);
    output += lastIndex > 0 && /^[\s,;]*$/.test(between) ? " " : between;
    const encoded = encodeURIComponent(JSON.stringify(clauseData));
    output += `<ClauseLink data="${encoded}"></ClauseLink>`;
    lastIndex = (regExpExec.index ?? 0) + regExpExec[0].length;
  }
  output += text.slice(lastIndex);
  return output;
}

export const replaceClauseObjectsWithTags = _.memoize(
  replaceClauseObjectsWithTagsImpl,
  clauseTemplateCacheKey,
);

export function extractClausepartsFromText(
  text: string,
  documentClauseparts: Clausepart[],
  documentSections: DocumentSection[],
  documentId?: number,
): Clausepart[] {
  const matches = processClauseLinkTemplate(
    text,
    documentClauseparts,
    documentSections,
    documentId,
  );
  return matches
    .filter(match => match.clauseData && !match.clauseData.hasFailed)
    .map(match =>
      documentClauseparts.find(
        cp => cp.id === (match.clauseData as {data: {id: unknown}}).data.id,
      ),
    )
    .filter((cp): cp is Clausepart => cp !== undefined);
}
